import { CURRENT_TERMS_VERSION } from '../legal/termsVersion';

export interface TermsAcceptanceProfile {
  /** Set true only when provisioning a new user who must accept ToS once. */
  requiresTermsAcceptance?: boolean | null;
  termsAcceptedAt?: number | null;
  termsVersion?: string | null;
}

/**
 * Terms are required only for newly provisioned users (requiresTermsAcceptance).
 * Existing accounts without the flag are grandfathered — they already accepted offline.
 */
export function needsTermsAcceptance(input: {
  firebaseAuth: boolean;
  profile: TermsAcceptanceProfile | null;
  /** When profile has not loaded yet, do not block. */
  profileLoaded: boolean;
}): boolean {
  if (!input.firebaseAuth) return false;
  if (!input.profileLoaded) return false;
  if (input.profile?.requiresTermsAcceptance !== true) return false;

  const version = input.profile.termsVersion;
  const acceptedAt = input.profile.termsAcceptedAt;
  if (acceptedAt && version === CURRENT_TERMS_VERSION) return false;
  return true;
}
